import React from "react";
import GoogleMapReact from "google-map-react";
import "./map.css";
import LocationPin from "./LocationPin";

function CustomMap({ mapData, setBackdrop = () => {}, fullScreen = false }) {
  const defaultProps = {
    center: {
      // convert to number
      lat: Number(mapData.lat),
      lng: Number(mapData.lng),
    },
    zoom: 18,
    address: mapData.address,
  };

  return (
    <div
      style={
        fullScreen
          ? { height: "100vh", width: "100%" }
          : { height: "70vh", width: "100%" }
      }
      className='customized-map'
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyAHeix3Mf1YRppXp1hxArkPwkevOZFc1Ew" }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        //button for change map type
        options={{
          mapTypeControl: true,
          streetViewControl: true,
          fullscreenControl: true,
          mapTypeId: "satellite",
        }}
      >
        <LocationPin
          lat={defaultProps.center.lat}
          lng={defaultProps.center.lng}
          mapData={mapData}
          setBackdrop={setBackdrop}
        />
      </GoogleMapReact>
    </div>
  );
}

export default CustomMap;
